import React, { useEffect } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { Button } from '@/shared/ui/Button';
import { IconButton } from '@/shared/ui/Button/IconButton';
import { useAppDispatch, useAppSelector } from '@/app/store/hooks';
import { closeMobileSidebar, setMenuItemActive } from '../model/slice';
import { selectMenuItems, selectMobileSidebarOpen } from '../model/selectors';
import { cn } from '@/shared/lib/utils';

// Icons
import Logo from '@/assets/icons/logo.svg?react';
import Telegram from '@/assets/icons/telegram.svg?react';
import Whatsapp from '@/assets/icons/whatsapp.svg?react';
import Phone from '@/assets/icons/phone.svg?react';

import Home from '@/assets/icons/main.svg?react';
import Book from '@/assets/icons/book.svg?react';
import Close from '@/assets/icons/close.svg?react';
import { contactsType } from '@/entities/home_content/model/types';

const menuIconsMap = [
  <Home className='h-[32px] w-[34px]'/>,
  <Book className='h-[32px] w-[34px]'/>
];

type MobileSidebarProps = {
  contacts?: contactsType
}

export default function MobileSidebar({ contacts }: MobileSidebarProps) {

  const location = useLocation();
  const url = location.pathname;

  const dispatch = useAppDispatch();
  const open = useAppSelector(selectMobileSidebarOpen);
  const menu = useAppSelector(selectMenuItems);

  const handleCloseMobileSidebar = () => {
    dispatch(closeMobileSidebar());
  };

  // Закрытие при смене маршрута
  React.useEffect(() => {
    if (open) {
      handleCloseMobileSidebar();
    }
  }, [location.pathname]);

  // Управление scroll'ом body
  React.useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : 'auto';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [open]);

  useEffect(() => {
    dispatch(setMenuItemActive({ url: url }))
  }, [url])

  return (
    <div
      className={cn(
        'fixed w-screen h-screen z-50 top-0 left-0 flex justify-end transition-transform bg-black/80 xl:hidden',
        open ? 'translate-x-0' : 'translate-x-full'
      )}
    >
      {/* Клик по фону */}
      <div
        className="absolute inset-0"
        onClick={handleCloseMobileSidebar}
      />

      <div
        className="relative bg-[#FFFFFFF7] w-[90%] md:w-[70%] h-min rounded-tl-[30px] rounded-bl-[30px]
          flex flex-col overflow-hiden gap-[40px] pt-[20px] pb-[78px] px-[20px] z-20
        "
      >
        <IconButton
          icon={<Close />}
          className="shadow-cls w-[40px] h-[40px] self-end bg-[#FFFFFF99]"
          onClick={handleCloseMobileSidebar}
        />

        <ul className="flex flex-col w-full gap-[20px] px-[20px]">
          {menu.map((item, index) => (
            <li key={index}>
              <NavLink
                to={item.link}
                className={cn(
                  'normal flex items-center h-[48px] px-[10px] py-[8px] gap-[12px] whitespace-nowrap transition-all font-medium rounded-[10px] hover:text-[#0000001A]',
                  item.active && 'bg-[var(--black-light-2)]'
                )
                }
              >
                {menuIconsMap[index]}
                {item.name}
              </NavLink>
            </li>
          ))}
        </ul>

        <div className="flex flex-col items-center gap-[20px]">
          <div className="flex gap-[8px] items-center">
            <a href={contacts?.telegramUrl} target='_block'><Telegram className='w-[36px] h-[35px]' /></a>
            <a href={contacts?.whatsappUrl} target='_block'><Whatsapp className='w-[36px] h-[35px]' /></a>
          </div>

          <a href={`tel:${contacts ? contacts.phoneNumbers[0] : '+7 (495)137-97-65'}`}>
            <Button
              startIcon={<Phone className='stroke-white' />}
              text={contacts ? contacts.phoneNumbers[0] : '+7 (495)137-97-65'}
              className="h-[40px] px-[28px] text-[14px] bg-black text-white flex"
              bg="white"
            />
          </a>
        </div>

        <Logo className="w-[200px] h-[31px] self-center" />
      </div>
    </div>
  );
}
